<template>
  <section class="my-skills-section" id="my-skills-section">
    <div class="flex flex-column flex-justify-center flex-align-center">
      <h1>SKILLS</h1>
      <div
        class="container flex flex-row flex-justify-center flex-align-center flex-wrap"
      >
        <my-skill v-for="skill in skills" :key="skill.id" :skill="skill" />
      </div>
    </div>
  </section>
</template>
<script>
import mySkill from "./mySkill.vue";
export default {
  components: { mySkill },
  data() {
    return {
      startpoint: 2.4,
      endPoint: 3.5,
      skills: [
        { id: "html", title: "HTML" },
        { id: "dotnet", title: ".NET" },
        { id: "cSharp", title: "C#" },
        { id: "java", title: "Java" },
        { id: "python", title: "Python" },
        { id: "sql", title: "SQL" },
        { id: "frontDev", title: "FRONTEND DEVELOPMENT" },
        { id: "backDev", title: "BACKEND DEVELOPMENT" },
        { id: "css", title: "CSS" },
        { id: "bem", title: "BEM" },
        { id: "vue", title: "VueJS" },
        { id: "react", title: "ReactJS" },
        { id: "node", title: "NodeJS" },
        { id: "rest", title: "REST" },
        { id: "serialCommunication", title: "Serial Communication" },
        { id: "scrum", title: "Scrum" },
        { id: "weblogic", title: "WebLogic" },
        { id: "SNMP", title: "SNMP" },
      ],
    };
  },
  methods: {
    animateOverlay(scrollPosition) {
      var opacity = 1;
      if (scrollPosition >= this.startpoint) {
        opacity = Math.max(this.endPoint - scrollPosition, 0.6);
      } else if (scrollPosition >= this.endPoint) {
        opacity = 0.6;
      } else {
        opacity = 1;
      }
      document.getElementById("router-view").style.backgroundColor =
        "rgb(22, 22, 22," + opacity + ")";
    },
  },
  created() {
    this.$store.subscribeAction({
      after: (action) => {
        if (action.type === "setScrollPosition") {
          this.animateOverlay(action.payload.scrollPosition);
        }
      },
    });
  },
};
</script>
<style lang="scss" scoped>
.my-skills-wrapper {
  height: 100%;
  width: 100%;
  // background-image: url("../../assets/red-clouds.jpg");
  // background-repeat: no-repeat;
  // background-size: cover;
  // background-position: center;
  // mask-image: linear-gradient(to top, black 0%, black 100%),
  //   linear-gradient(to top, transparent 0%, black 100%),
  //   linear-gradient(to bottom, transparent 0%, black 100%);
  // mask-position: center, top, right, bottom, left;
  // mask-size: 100% 100%, 100% 100px, 10px 100%, 100% 100px, 10px 100%;
  // mask-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  // mask-composite: subtract, add, add, add;
}
// .my-skills-section {
//   background-color: #161616;
// }
</style>
